import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
import JSEditProfileForm from '../../forms/JSEditProfileForm';
// helpers
import { resultInfo } from '../../helpers';
// mui
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APEditResume = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');
  const { t } = useTranslation('global');

  const [loading, setLoading] = useState(true);
  const [faculties, setFaculties] = useState([]);
  const [directories, setDirectories] = useState({});
  const [profileBody, setProfileBody] = useState({});

  const { profile_image = '' } = profileBody;

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/admin/resumes/edit/${id}`,
        null,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);

      const data = response.data.response;
      const userDetail = data.userdetail;

      setDirectories(data);
      setProfileBody(userDetail);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const handleSubmit = async values => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('jobseekerEditProfile.no'),
        confirmButtonText: t('jobseekerEditProfile.yes'),
        title: t('jobseekerEditProfile.editConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/resumes/save/${id}`,
          values,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setLoading(false);

        if (response.data.status === 200) {
          navigate('/admin/resumes');

          resultInfo('success', t('jobseekerEditProfile.editSuccessTitle'), t('jobseekerEditProfile.close'));
        }  else {
          resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
        }
      }
    } catch (error) {
      setLoading(false);

      resultInfo('error', t('jobseekerEditProfile.editFailedTitle'), t('jobseekerEditProfile.close'));

      console.error('Could not submit edit data!', error);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); //eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      to={'/admin/admins/dashboard'}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      to={'/admin/resumes'}
                    >
                      Resumes
                    </Link>
                    <Typography color='text.primary'>Edit Resume</Typography>
                  </Breadcrumbs>
                </div>
                <div
                  className='col-lg-9 mb-5'
                  style={{
                    borderLeft: '2px solid #e6e8e7',
                    borderRight: '2px solid #e6e8e7',
                  }}
                >
                  <div className='mx-lg-3 d-flex PageHeader'>
                    <img src='/Images/employerSide/icon8color.png' alt='' />
                    <h3>Edit Resume</h3>
                  </div>
                  <div className='JSEPFirstSegment'>
                    <div className='profileImageBox'>
                      <img
                        alt='profile image'
                        className='profileImage'
                        src={profile_image ? profile_image : '/Images/jobseekerSide/dummy-profile.png'}
                      />
                    </div>
                  </div>
                  {
                    profileBody != '' && (
                      <JSEditProfileForm
                        id={id}
                        faculties={faculties}
                        directories={directories}
                        profileBody={profileBody}
                        handleSubmit={handleSubmit}
                        setFaculties={setFaculties}
                      />
                    )
                  }
                </div>
              </div>
            )}
      </div>
    </>
  );
};

export default APEditResume;
